import { Path } from 'react-hook-form'
import { StringField } from './StringField'
import { DateField } from './DateField'
import { DateTimeField } from './DateTimeField'
import { FileField } from './FileField'
import { UriField } from './UriField'
import { NumberField } from './NumberField'
import { SliderField } from './SliderField'
import { BooleanField } from './BooleanField'
import { MultiSelectComboboxField } from './MultiSelectComboboxField'
import { BaseFieldProps, FormValues, JsonFormPropertyV2 } from './types'
import { SingleSelectComboboxField } from './SingleSelectComboboxField'
import { TextAreaField } from './TextAreaField'
import { CascadingField } from './CascadingField/index'

interface FieldRendererProps {
  field: JsonFormPropertyV2
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any
  variant?: BaseFieldProps['variant']
}

export const FieldRenderer: React.FC<FieldRendererProps> = ({ field, control, variant = 'column' }) => {
  const formFieldName = field.id as Path<FormValues>

  switch (field.type) {
    case 'string':
      if (field.format === 'date') {
        return <DateField field={field} formFieldName={formFieldName} control={control} />
      }

      if (field.format && ['date-time', 'datetime'].includes(field.format)) {
        return <DateTimeField field={field} formFieldName={formFieldName} control={control} />
      }

      if (field.format === 'file-url') {
        return <FileField field={field} formFieldName={formFieldName} control={control} />
      }

      if (field.format === 'uri') {
        return <UriField field={field} formFieldName={formFieldName} control={control} />
      }

      if (field.widget === 'textarea') {
        return <TextAreaField field={field} formFieldName={formFieldName} control={control} />
      }

      if (field.choices) {
        // return <SelectField field={field} formFieldName={formFieldName} control={control} layout={layout} />
        return (
          <SingleSelectComboboxField
            field={field}
            formFieldName={formFieldName}
            control={control}
            variant={variant}
            showIcons={field.id === 'icon_name'}
          />
        )
      }

      return <StringField field={field} formFieldName={formFieldName} control={control} />

    case 'integer':
    case 'number':
      if (field.widget === 'range') {
        return <SliderField field={field} formFieldName={formFieldName} control={control} />
      }

      return <NumberField field={field} formFieldName={formFieldName} control={control} />

    case 'boolean':
      return <BooleanField field={field} formFieldName={formFieldName} control={control} />

    case 'array':
      if (field.items?.widget === 'multiselect' && field.items?.choices) {
        return (
          <MultiSelectComboboxField field={field} formFieldName={formFieldName} control={control} variant={variant} />
        )
      }
      return null

    case 'cascading':
      return variant === 'column' ? (
        <div className="flex flex-1 rounded-md bg-grey-lightest p-3">
          <CascadingField field={field} formFieldName={formFieldName} control={control} variant={variant} />
        </div>
      ) : (
        <CascadingField field={field} formFieldName={formFieldName} control={control} variant={variant} />
      )

    default:
      return null
  }
}
